import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor } from '../../badges/interfaces';

@Component({
  selector: 'onyx-widget-box',
  imports: [TranslatePipe],
  templateUrl: './onyx-widget-box.component.html',
  styleUrl: './onyx-widget-box.component.scss',
})
export class OnyxWidgetBoxComponent {
  public readonly heading = input.required<string>();
  public readonly color = input<OnyxColor>('gray');
  public readonly hover = input(false);
}
